"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const silica_1 = require("@opendoor/silica");
const CheckCircleOutlineRounded_1 = __importDefault(require("@material-ui/icons/CheckCircleOutlineRounded"));
const ChevronRightRounded_1 = __importDefault(require("@material-ui/icons/ChevronRightRounded"));
const ErrorOutlineRounded_1 = __importDefault(require("@material-ui/icons/ErrorOutlineRounded"));
const InfoOutlined_1 = __importDefault(require("@material-ui/icons/InfoOutlined"));
const KeyboardArrowDownRounded_1 = __importDefault(require("@material-ui/icons/KeyboardArrowDownRounded"));
const WarningRounded_1 = __importDefault(require("@material-ui/icons/WarningRounded"));
const graphik = [
    {
        fontFamily: 'Graphik',
        fontStyle: 'normal',
        fontWeight: 400,
        src: `
      local("Graphik-Regular"),
      local("Graphik"),
      url("https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2") format("woff2")
    `,
    },
    {
        fontFamily: 'Graphik',
        fontStyle: 'normal',
        fontWeight: 500,
        src: `
      local("Graphik-Medium"),
      local("Graphik"),
      url("https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2") format("woff2")
    `,
    },
    {
        fontFamily: 'Graphik',
        fontStyle: 'normal',
        fontWeight: 600,
        src: `
      local("Graphik-Semibold"),
      local("Graphik"),
      url("https://cdn.opendoor.com/fonts/Graphik-Semibold-Web.woff2") format("woff2")
    `,
    },
    {
        fontFamily: 'Graphik',
        fontStyle: 'normal',
        fontWeight: 700,
        src: `
      local("Graphik-Bold"),
      local("Graphik"),
      url("https://cdn.opendoor.com/fonts/Graphik-Bold-Web.woff2") format("woff2")
    `,
    },
];
exports.default = {
    palette: {
        type: 'light',
        primary: {
            light: silica_1.colors.blue4,
            main: silica_1.colors.blue4,
            dark: silica_1.colors.blue5,
            contrastText: silica_1.colors.white,
        },
        secondary: {
            // same as main, tbd if this is problematic or not
            light: silica_1.colors.gray4,
            main: silica_1.colors.gray4,
            dark: silica_1.colors.gray5,
            contrastText: silica_1.colors.white,
        },
        error: {
            // light: colors.red1,
            main: silica_1.colors.red4,
            // dark: colors.red1,
            contrastText: silica_1.colors.red1,
        },
        success: {
            // light: colors.green1,
            main: silica_1.colors.green1,
            // dark: colors.green1,
            contrastText: silica_1.colors.green4,
        },
        warning: {
            // light: colors.yellow1,
            main: silica_1.colors.yellow1,
            // dark: colors.yellow1,
            contrastText: silica_1.colors.yellow4,
        },
        info: {
            light: silica_1.colors.blue1,
            main: silica_1.colors.blue2,
            dark: silica_1.colors.blue3,
            contrastText: silica_1.colors.blue6,
        },
        grey: {
            // 50:
            100: silica_1.colors.gray1,
            200: silica_1.colors.gray2,
            300: silica_1.colors.gray3,
            400: silica_1.colors.gray3,
            500: silica_1.colors.gray4,
            600: silica_1.colors.gray4,
            700: silica_1.colors.gray5,
            800: silica_1.colors.gray6,
            900: silica_1.colors.gray6,
            A100: silica_1.colors.gray1,
            A200: silica_1.colors.gray2,
            A400: silica_1.colors.gray3,
            A700: silica_1.colors.gray4,
        },
        common: {
            white: silica_1.colors.white,
            black: silica_1.colors.black,
        },
        text: {
            // @Hamza - Should we change secondary to gray6?
            // Our other palettes have a secondary darker than the primary
            primary: silica_1.colors.gray5,
            secondary: silica_1.colors.gray6,
            disabled: silica_1.colors.gray3,
            hint: silica_1.colors.blue5,
        },
        background: {},
        action: {
            active: silica_1.colors.blue4,
            hover: silica_1.colors.gray2,
            hoverOpacity: 0.1,
            selected: silica_1.colors.gray3,
            disabled: silica_1.colors.gray3,
            disabledBackground: silica_1.colors.white,
        },
    },
    spacing: (factor) => {
        const key = (factor + '');
        if (silica_1.spacingSizes.hasOwnProperty(key)) {
            const spacingSize = silica_1.spacingSizes[key];
            return spacingSize.startsWith('.') ? '0' + spacingSize : spacingSize;
        }
        const halfFactor = Math.floor(factor / 2);
        const factorIsEven = !!(factor % 2);
        const multiplier = factor ? Math.pow(2, halfFactor - 4) : 0;
        const remValue = factorIsEven ? multiplier * 4 : multiplier * 3;
        return remValue + 'rem';
    },
    typography: {
        fontFamily: "'Graphik', sans-serif",
        h1: {
            fontSize: silica_1.fontSizes['3'],
            fontWeight: 600,
        },
        h2: {
            fontSize: silica_1.fontSizes['4'],
            fontWeight: 600,
        },
        h3: {
            fontSize: silica_1.fontSizes['5'],
            fontWeight: 600,
        },
        h4: {
            fontSize: silica_1.fontSizes['6'],
            fontWeight: 600,
        },
        h5: {
            fontSize: silica_1.fontSizes['7'],
            fontWeight: 600,
        },
        h6: {
            fontSize: silica_1.fontSizes['8'],
            fontWeight: 600,
        },
        body1: {
            fontSize: silica_1.fontSizes['6'],
        },
        body2: {
            fontSize: silica_1.fontSizes['7'],
        },
        caption: {
            color: silica_1.colors.gray4,
        },
    },
    // Set default props for elements
    props: {
        // TODO Include these customizations in mosaic-docs
        MuiAlert: {
            variant: 'filled',
            severity: 'info',
            iconMapping: {
                info: react_1.default.createElement(InfoOutlined_1.default, { fontSize: "inherit" }),
                success: react_1.default.createElement(CheckCircleOutlineRounded_1.default, { fontSize: "inherit" }),
                warning: react_1.default.createElement(WarningRounded_1.default, { fontSize: "inherit" }),
                error: react_1.default.createElement(ErrorOutlineRounded_1.default, { fontSize: "inherit" }),
            },
        },
        MuiButton: {
            disableElevation: true,
            variant: 'contained',
        },
        MuiTooltip: {
            arrow: true,
        },
        MuiLink: {
            color: 'primary',
        },
        MuiBreadcrumbs: {
            separator: react_1.default.createElement(ChevronRightRounded_1.default, null),
        },
        MuiTextField: {
            // It's funky, but we really want this oneinput style
            InputLabelProps: {
                shrink: true,
            },
            variant: 'outlined',
        },
        MuiAutocomplete: {
            popupIcon: react_1.default.createElement(KeyboardArrowDownRounded_1.default, null),
        },
        MuiSelect: {
            variant: 'outlined',
            IconComponent: KeyboardArrowDownRounded_1.default,
        },
        MuiSnackbarContent: {
            // Remove box-shadow from the Paper element backing SnackbarContent
            elevation: 0,
        },
        MuiCheckbox: {
            color: 'primary',
        },
        MuiRadio: {
            color: 'primary',
        },
    },
    overrides: {
        MuiAvatar: {
            colorDefault: {
                color: silica_1.colors.white,
                backgroundColor: silica_1.colors.gray4,
            },
            root: {
                userSelect: 'unset',
                width: silica_1.widths['4'],
                height: silica_1.heights['4'],
                fontSize: silica_1.fontSizes['5'],
                fontWeight: 600,
            },
        },
        MuiInputLabel: {
            outlined: {
                // Override and remove existing transforms to place the label above the OutlinedInput border
                transform: 'none',
                // Override the absolute positioning of MuiInputLabel-formControl
                position: 'unset',
                // Allow clicking the label to focus the form element
                pointerEvents: 'unset',
                marginBottom: silica_1.spacingSizes['3'],
                marginTop: silica_1.spacingSizes['3'],
                '&$shrink': {
                    transform: 'none',
                    marginBottom: silica_1.spacingSizes['3'],
                    marginTop: silica_1.spacingSizes['3'],
                },
            },
        },
        MuiSelect: {
            /*
            outlined: {
              border: 'unset',
              borderWidth: borderSizes['1'],
              borderColor: colors.gray3,
              borderStyle: 'solid',
            },
            */
            iconOutlined: {
                padding: 'unset',
            },
        },
        MuiTablePagination: {
            selectIcon: {
                top: 'unset',
                color: silica_1.colors.gray4,
            },
        },
        MuiSnackbarContent: {
            root: {
                backgroundColor: silica_1.colors.blue2,
                color: silica_1.colors.gray6,
                // Icons in Snackbars are generally white
                '& .MuiSvgIcon-root': {
                    color: silica_1.colors.white,
                },
                '&[class*="SnackbarItem"]': {
                    paddingLeft: silica_1.spacingSizes['5'],
                },
                // error/info/success/warning `notistack` variants
                '&[class*="variantInfo"]': {
                    backgroundColor: silica_1.colors.blue4,
                    color: silica_1.colors.white,
                },
                '&[class*="variantSuccess"]': {
                    backgroundColor: silica_1.colors.green4,
                    color: silica_1.colors.white,
                },
                '&[class*="variantError"]': {
                    backgroundColor: silica_1.colors.red4,
                    color: silica_1.colors.white,
                },
                '&[class*="variantWarning"]': {
                    backgroundColor: silica_1.colors.yellow1,
                    color: silica_1.colors.yellow4,
                    '& .MuiSvgIcon-root': {
                        color: silica_1.colors.yellow4,
                    },
                },
            },
        },
        MuiFormLabel: {
            // TODO diagnose label alignment of variant="filled" Autocomplete
            root: {
                fontSize: silica_1.fontSizes['8'],
                fontWeight: 'bold',
                '&$error': {
                    color: undefined,
                },
                '&$focused': {
                    color: undefined,
                },
            },
        },
        // TODO Krone/Hamza fix IconButton `disabled` colors!
        MuiCssBaseline: {
            '@global': {
                '@font-face': graphik,
            },
        },
        MuiIconButton: {
            root: {
                color: silica_1.colors.gray5,
            },
        },
        MuiOutlinedInput: {
            inputMarginDense: {
                paddingTop: silica_1.spacingSizes['3'],
                paddingBottom: silica_1.spacingSizes['3'],
            },
            input: {
                height: 'auto',
                lineHeight: '1',
                padding: silica_1.spacingSizes['5'] + ' ' + silica_1.spacingSizes['4'],
            },
            multiline: {
                padding: silica_1.spacingSizes['5'] + ' ' + silica_1.spacingSizes['4'],
            },
            notchedOutline: {
                borderStyle: 'solid',
                borderWidth: silica_1.borderSizes['1'],
                borderColor: silica_1.colors.gray3,
                borderRadius: silica_1.borderRadii['2'],
                '& > legend > *': {
                    // remove the 'notched' cut-out of the Outlined Input because we move the label text from its space there
                    display: 'none',
                },
            },
            adornedEnd: {
                paddingRight: undefined,
            },
            inputAdornedStart: {
                // TODO apply to all Inputs (not just outlined)
                paddingLeft: silica_1.spacingSizes['4'],
            },
        },
        MuiBreadcrumbs: {
            root: {
                '& .MuiTypography-root': {
                    fontWeight: 'bold',
                },
                '& .MuiSvgIcon-root': {
                    color: silica_1.colors.gray3,
                },
            },
        },
        MuiBackdrop: {
            root: {
                backgroundColor: `${silica_1.colors.black}ba`,
            },
        },
        // @material-ui/pickers Date pickers
        MuiPickersDay: {
            current: {
                '& .MuiTypography-body2': {
                    fontWeight: 'bold',
                },
            },
            dayDisabled: {
                color: silica_1.colors.gray3,
            },
        },
        MuiPickersCalendarHeader: {
            dayLabel: {
                fontWeight: 'bold',
            },
        },
        MuiButton: {
            root: {
                color: silica_1.colors.gray5,
                textTransform: 'initial',
                fontSize: silica_1.fontSizes['6'],
                lineHeight: '24px',
                fontWeight: 'bold',
                padding: `${silica_1.spacingSizes['3']} ${silica_1.spacingSizes['5']}`,
                minWidth: 'unset',
                // remove the transition as it is out of sync with the icon transition
                transition: 'none',
                '&:hover': {
                    color: silica_1.colors.blue6,
                },
                // svg colors
                '& .MuiSvgIcon-root': {
                    stroke: 'transparent',
                    fill: 'currentColor',
                    // remove the svg transition as it is out of sync with the button
                    transition: 'none',
                },
                '&:hover .MuiSvgIcon-root': {
                    fill: 'currentColor',
                },
                '&.Mui-disabled .MuiSvgIcon-root': {
                    fill: 'currentColor',
                },
            },
            containedPrimary: {
                '& .MuiSvgIcon-root': {
                    fill: silica_1.colors.white,
                },
            },
            containedSecondary: {
                color: silica_1.colors.black,
                backgroundColor: silica_1.colors.gray2,
                '& .MuiSvgIcon-root': {
                    fill: silica_1.colors.black,
                },
                '&:hover': {
                    color: silica_1.colors.black,
                    backgroundColor: silica_1.colors.gray3,
                },
                '&:hover .MuiSvgIcon-root': {
                    fill: silica_1.colors.black,
                },
            },
            sizeSmall: {
                fontSize: silica_1.fontSizes['8'],
            },
            sizeLarge: {
                padding: `${silica_1.spacingSizes['4']} ${silica_1.spacingSizes['6']}`,
                fontSize: silica_1.fontSizes['6'],
            },
            text: {
                // Ensure text Buttons have the same sizing as other variants
                padding: undefined,
                '&:hover': {
                    backgroundColor: silica_1.colors.blue3,
                    '& .MuiSvgIcon-root': {
                        fill: silica_1.colors.blue6,
                    },
                },
            },
            textPrimary: {
                color: silica_1.colors.blue5,
                '&:hover': {
                    backgroundColor: silica_1.colors.blue3,
                },
                '& .MuiSvgIcon-root': {
                    fill: silica_1.colors.blue5,
                },
            },
            textSecondary: {
                color: silica_1.colors.gray4,
                '&:hover': {
                    backgroundColor: silica_1.colors.gray2,
                },
            },
            outlined: {
                // Match the padding of MuiButton-root while accounting for the 1px border of outlined buttons
                padding: `calc(${silica_1.spacingSizes['3']} - 1px) calc(${silica_1.spacingSizes['5']} - 1px)`,
                borderColor: silica_1.colors.gray4,
                '& .MuiSvgIcon-root': {
                    fill: silica_1.colors.gray5,
                },
                // All outlined buttons use this hover effect
                '&:hover': {
                    color: silica_1.colors.blue6,
                    backgroundColor: 'transparent',
                    borderColor: silica_1.colors.blue6,
                    '& .MuiSvgIcon-root': {
                        fill: silica_1.colors.blue6,
                    },
                },
            },
            outlinedSizeLarge: {
                '&$sizeLarge': {
                    // for specificity, to override $sizeLarge
                    padding: `calc(${silica_1.spacingSizes['4']} - 1px) calc(${silica_1.spacingSizes['6']})`,
                },
            },
            outlinedSizeSmall: {
                '&$sizeSmall': {
                    // for specificity, to override $sizeSmall
                    padding: `calc(${silica_1.spacingSizes['2']} - 1px) ${silica_1.spacingSizes['3']}`,
                },
            },
            startIcon: {
                '&$iconSizeSmall': {
                    marginLeft: 0,
                    marginRight: silica_1.spacingSizes['2'],
                },
            },
            endIcon: {
                '&$iconSizeSmall': {
                    marginLeft: silica_1.spacingSizes['2'],
                    marginRight: 0,
                },
            },
            // color-related
            contained: {
                color: silica_1.colors.gray6,
                backgroundColor: silica_1.colors.gray2,
                '&:hover': {
                    color: silica_1.colors.white,
                    backgroundColor: silica_1.colors.blue5,
                },
            },
            outlinedPrimary: {
                color: silica_1.colors.blue4,
                borderColor: silica_1.colors.blue4,
                '& .MuiSvgIcon-root': {
                    fill: silica_1.colors.blue4,
                },
                '&:hover': {
                    backgroundColor: undefined,
                    borderColor: silica_1.colors.blue6,
                },
            },
            outlinedSecondary: {
                borderColor: silica_1.colors.gray4,
                color: silica_1.colors.gray4,
                '& .MuiSvgIcon-root': {
                    fill: silica_1.colors.gray4,
                },
                '&:hover': {
                    borderColor: silica_1.colors.gray6,
                    color: silica_1.colors.gray6,
                    backgroundColor: undefined,
                    border: undefined,
                    borderWidth: '1px',
                    borderStyle: 'solid',
                },
            },
        },
        MuiChip: {
            root: {
                backgroundColor: silica_1.colors.gray2,
            },
            outlined: {
                borderColor: silica_1.colors.gray4,
            },
            deleteIcon: {
                color: silica_1.colors.gray4,
            },
            deleteIconOutlinedColorPrimary: {
                color: silica_1.colors.blue5,
                '&:hover, &:active': {
                    color: silica_1.colors.blue6,
                },
            },
        },
        MuiDivider: {
            root: {
                height: '0.125rem',
                backgroundColor: silica_1.colors.gray2,
            },
            vertical: {
                height: 'auto',
                width: '0.125rem',
            },
        },
        MuiLinearProgress: {
            colorPrimary: {
                backgroundColor: silica_1.colors.blue3,
            },
            colorSecondary: {
                backgroundColor: silica_1.colors.blue3,
            },
        },
        MuiFormHelperText: {
            contained: {
                marginTop: silica_1.spacingSizes['3'],
                marginRight: silica_1.spacingSizes[0],
                marginBottom: silica_1.spacingSizes[0],
                marginLeft: silica_1.spacingSizes[0],
            },
        },
        // Dialog
        MuiDialog: {
            root: {
                '& .MuiIconButton-root': {
                    padding: silica_1.spacingSizes['6'],
                },
            },
        },
        MuiDialogTitle: {
            root: {
                maxWidth: '85%',
                padding: `28px ${silica_1.spacingSizes[6]}`,
            },
        },
        MuiDialogActions: {
            root: {
                padding: `${silica_1.spacingSizes[5]} ${silica_1.spacingSizes[6]}`,
            },
            spacing: {
                '& > :not(:first-child)': {
                    marginLeft: silica_1.fontSizes[6],
                },
            },
        },
        MuiInputBase: {
            root: {
                fontSize: 'inherit',
            },
            marginDense: {
                '& .MuiSvgIcon-root': {
                    height: silica_1.heights[1],
                    width: silica_1.widths[1],
                },
            },
        },
        MuiTabs: {
            root: {
                marginBottom: '-2px',
            },
            indicator: {
                backgroundColor: silica_1.colors.blue4,
            },
            scroller: {
                display: 'inline-flex',
                alignItems: 'center',
            },
        },
        MuiAlert: {
            standardInfo: {
                color: silica_1.colors.blue4,
                backgroundColor: silica_1.colors.blue1,
                '& $icon': {
                    color: silica_1.colors.blue4,
                },
            },
            standardSuccess: {
                color: silica_1.colors.green4,
                backgroundColor: silica_1.colors.green1,
                '& $icon': {
                    color: silica_1.colors.green4,
                },
            },
            standardWarning: {
                color: silica_1.colors.yellow4,
                backgroundColor: silica_1.colors.yellow1,
                '& $icon': {
                    color: silica_1.colors.yellow4,
                },
            },
            standardError: {
                color: silica_1.colors.red4,
                backgroundColor: silica_1.colors.red1,
                '& $icon': {
                    color: silica_1.colors.red4,
                },
            },
            filledInfo: {
                color: silica_1.colors.blue1,
                backgroundColor: silica_1.colors.blue4,
            },
            filledSuccess: {
                color: silica_1.colors.green1,
                backgroundColor: silica_1.colors.green4,
            },
            filledWarning: {
                color: silica_1.colors.yellow4,
                backgroundColor: silica_1.colors.yellow1,
            },
            filledError: {
                color: silica_1.colors.red1,
                backgroundColor: silica_1.colors.red4,
            },
            outlinedInfo: {
                color: silica_1.colors.blue4,
                border: `${silica_1.borderSizes['1']} solid ${silica_1.colors.blue4}`,
                '& $icon': {
                    color: silica_1.colors.blue4,
                },
            },
            outlinedSuccess: {
                color: silica_1.colors.green4,
                border: `${silica_1.borderSizes['1']} solid ${silica_1.colors.green4}`,
                '& $icon': {
                    color: silica_1.colors.green4,
                },
            },
            outlinedWarning: {
                color: silica_1.colors.yellow4,
                border: `${silica_1.borderSizes['1']} solid ${silica_1.colors.yellow4}`,
                '& $icon': {
                    color: silica_1.colors.yellow4,
                },
            },
            outlinedError: {
                color: silica_1.colors.red4,
                border: `${silica_1.borderSizes['1']} solid ${silica_1.colors.red4}`,
                '& $icon': {
                    color: silica_1.colors.red4,
                },
            },
        },
        MuiTab: {
            root: {
                textTransform: 'none',
                fontSize: silica_1.fontSizes['7'],
                minWidth: 'unset',
                maxWidth: 'unset',
                fontWeight: 600,
                paddingLeft: silica_1.spacingSizes['4'],
                paddingRight: silica_1.spacingSizes['4'],
                marginLeft: silica_1.spacingSizes['2'],
                '@media (min-width:600px)': {
                    // corresponds with 'sm' up breakpoint
                    fontSize: silica_1.fontSizes['7'],
                    minWidth: 'unset',
                },
            },
            textColorInherit: {
                '&.Mui-selected': {
                    color: silica_1.colors.blue4,
                },
            },
        },
        MuiTableBody: {
            root: {
                fontSize: 14,
            },
        },
        MuiTableHead: {
            root: {
                fontWeight: 600,
            },
        },
        MuiTableRow: {
            root: {
                '&:nth-child(odd)': {
                    backgroundColor: silica_1.colors.blue1,
                },
                '&:hover': {
                    transform: 'scale(1)',
                    boxShadow: '0px 5px 10px rgba(5, 32, 57, 0.25), 0px 4px 4px rgba(5, 32, 57, 0.25)',
                },
            },
            head: {
                backgroundColor: silica_1.colors.white,
                '&:nth-child(odd)': {
                    backgroundColor: silica_1.colors.white,
                },
                '&:hover': {
                    boxShadow: 'none',
                },
            },
        },
        MuiTableCell: {
            root: {
                borderBottom: 'none',
            },
            head: {
                fontWeight: 600,
                boxShadow: 'inset 0px -1px 0px #C7CFD7;',
            },
            stickyHeader: {
                backgroundColor: silica_1.colors.white,
            },
            body: {
                color: silica_1.colors.black,
            },
        },
        MuiTooltip: {
            tooltip: {
                backgroundColor: silica_1.colors.gray4,
            },
        },
    },
};
